// extracted by mini-css-extract-plugin
export default {"signing":"style_signing__QC94q"};